// src/utils/storage.js

const memoryStorage = new Map();

const browserStorages = () => [window.localStorage, window.sessionStorage];

/**
 * Read JSON assessment state from redundant browser storage.
 */
export const safeGet = (key, defaultValue = {}) => {
  for (const storage of browserStorages()) {
    try {
      const item = storage.getItem(key);
      if (item !== null) return JSON.parse(item);
    } catch (error) {
      console.warn(`[storage] Error reading key "${key}":`, error);
    }
  }
  if (memoryStorage.has(key)) return memoryStorage.get(key);
  return defaultValue;
};

/**
 * Write JSON state to localStorage, sessionStorage, and an in-page fallback.
 */
export const safeSet = (key, value) => {
  memoryStorage.set(key, value);
  const serialized = JSON.stringify(value);
  for (const storage of browserStorages()) {
    try {
      storage.setItem(key, serialized);
    } catch (error) {
      console.error(`[storage] Error setting key "${key}":`, error);
    }
  }
};

export const safeRemove = (key) => {
  memoryStorage.delete(key);
  for (const storage of browserStorages()) {
    try {
      storage.removeItem(key);
    } catch (error) {
      console.error(`[storage] Error removing key "${key}":`, error);
    }
  }
};

export const safeGetRaw = (key) => {
  for (const storage of browserStorages()) {
    try {
      const value = storage.getItem(key);
      if (value !== null) return value;
    } catch (error) {
      console.warn(`[storage] Error reading raw key "${key}":`, error);
    }
  }
  return memoryStorage.has(key) ? String(memoryStorage.get(key)) : null;
};

export const safeSetRaw = (key, value) => {
  memoryStorage.set(key, value);
  for (const storage of browserStorages()) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      console.error(`[storage] Error setting raw key "${key}":`, error);
    }
  }
};
